/**
 * Resolves the label shown on a hotspot marker (CAT-625).
 *
 * New Popup fields:
 * - iconType === 'number' → show iconValue (1–99)
 * - iconType === 'icon'   → no numeric label (mic / text / '+' by content type)
 *
 * When iconType is missing, keep the caller's legacy label
 * (ImageMap.variant, coordinates[2], index+1, etc.).
 */
export function resolveHotspotMarker(
  iconType: string | null | undefined,
  iconValue: number | null | undefined,
  legacyLabel: string | number | null,
  /** Used when iconType === 'icon' (e.g. '+' for text-only POPUP). */
  iconModeFallback: string | number | null = null
): string | number | null {
  if (iconType === 'number') {
    return iconValue ?? null;
  }

  if (iconType === 'icon') {
    return iconModeFallback;
  }

  return legacyLabel;
}
